/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-1",
    "aws_content_delivery_bucket": "vim-20250615170819-hostingbucket-main",
    "aws_content_delivery_bucket_region": "us-west-1",
    "aws_content_delivery_url": "https://d1frfl9dykaoiu.cloudfront.net"
};


export default awsmobile;
